export default () => (value: string) => {
  if (!/^[a-zA-Z0-9-]*$/.test(value)) return 'ra.validation.string'
  return undefined
}
